import { TableColumn } from '@shared/components/data-table/data-table.component';

export const O2O_STUCK_ALERT_COLUMNS: TableColumn[] = [
  {
    label: 'o2o.stuck_alert.table.inner_order_no',
    prop: 'innerOrderNo',
    width: 160,
  },
  {
    label: 'o2o.stuck_alert.table.hold_category',
    prop: 'holdCategory',
    width: 160,
    type: 'custom',
    template: 'holdCategoryTemplate',
  },
  {
    label: 'o2o.stuck_alert.table.fulfillment_status',
    prop: 'fulfillmentStatus',
    width: 160,
    type: 'custom',
    template: 'fulfillmentStatusTemplate',
  },
  {
    label: 'o2o.stuck_alert.table.stock_hold_expiry_time',
    prop: 'stockHoldExpiryTime',
    width: 170,
    type: 'custom',
    template: 'dateTimeTemplate',
  },
  {
    label: 'o2o.stuck_alert.table.detected_at',
    prop: 'detectedAt',
    width: 170,
    type: 'custom',
    template: 'dateTimeTemplate',
  },
  {
    label: 'o2o.stuck_alert.table.status',
    prop: 'status',
    width: 120,
    type: 'custom',
    template: 'statusTemplate',
  },
  {
    label: 'o2o.stuck_alert.table.resolved_at',
    prop: 'resolvedAt',
    width: 170,
    type: 'custom',
    template: 'dateTimeTemplate',
  },
];
